import { getFileInfo, resourceSearch, newFolders, toggleStar, operationFileOrFolder, rename, download, fileOrFolderInfo } from "@/api/drive/drive";
import { deleteShare, removeShare, deleteLinks, shareList, shareUserList, getLinkList, linkResourceList, shareResourceList, shareTargetResourceList, shareDownload } from "@/api/share/share";
import headers from '@/config/headers'
import { isThumb } from "@/utils/index";
import { replaceThumbDomain } from "@/config/index";
const drive = {
  state: {
    tasks: [], // 当前正在执行的任务数
    isList: true, // 列表模式/网格模式
    perPage: 21,
    total: 0, // 列表总数
    previewData: {
      file_ext: '',
      // 全屏：fullscreen、发布详情右侧嵌入页：fullscreen-top、内容预览页：inside
      position: 'inside',
      // 预览地址
      preview_path: '',
      // 预览组件
      previewer: 'unknowPreview',
      // 不支持预览说明、过期文字说明、不允许访问的文字说明
      message: ''
    },
    shareInfo: {}, // 分享或发布详情
    headers: headers,
    setting: {
      from: false,
      drive: null,
      tab: null,
      group: null
    },
    drive: 'my',  // 当前驱动位置my、persona、groupdisk
    tab: 'file',  // 当前tab
    datas: [],  // 数据
    loading: false, // 加载状态
    nothing: false, // 是否没有数据
    shareExpired: false, //分享的已过期
    groupNumber: null,  // 群盘ID
    group: null,
    listQuery: {  // 搜索条件
      group_number: null,
      number: 0,
      searchName: null,
      is_rec: false,
      is_star: false,
      category: 'all',
      disk_type: 'cloud',
      offset: 0
      // limit: 21
    },
    operationFileOrFolderData: { // 文件的增删改查的条件
      group_number: null,
      action: null,
      number: null,
      disk_type: "cloud",
      files_list: [{ number: null, type: null }]
    },
    sort: null, // 排序条件
    selectedFolder: null, // 树形列表中被选择的文件夹
    selectedDatas: [],  // 被选中的文件和文件夹
    share: {
      share_number: null,
      share_creater_name: null,
      link_number: null,
      link_creater_name: null
    },
    focusState: false // 聚焦状态
  },
  mutations: {
    changeTask(state, payload) {
      payload.task.state = payload.state;
      payload.task.job_type = payload.job_type;
      payload.task.run_percent = payload.run_percent;
      payload.task.message = payload.message;
    },
    addTask(state, payload) {
      state.tasks.push(payload);
    },
    setIsList(state, payload) {
      state.isList = payload;
    },
    setTotal(state, payload) {
      state.total = payload
    },
    setPreviewData(state, payload) {
      state.previewData.file_ext = payload.file_ext;
      // fullscreen 、fullscreen-top、inside
      state.previewData.position = payload.position ? payload.position : 'inside';
      state.previewData.preview_path = payload.preview_path;
      state.previewData.previewer = payload.previewer;
      state.previewData.message = payload.message;
    },
    // 设置分享/发布详情(用于模态框的跨组件共享数据)
    setShareInfo(state, payload) {
      state.shareInfo = payload
    },
    setGroup(state, payload) {
      state.group = payload
    },
    setSetting(state, payload) {
      state.setting.from = payload.from
      state.setting.drive = payload.drive
      state.setting.tab = payload.tab
      state.setting.group = payload.group
    },
    // 同时修改鼠标聚焦状态和编辑状态
    setFocusState2(state, payload) {
      state.focusState = payload.status
      if (!payload.status) {
        payload.data.isEdit = false
      }
    },
    // 修改鼠标聚焦状态
    setFocusState(state, payload) {
      state.focusState = payload
    },
    setDatas(state, payload) {
      state.datas = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setShareExpired(state, payload) {
      state.shareExpired = payload
    },
    setNothing(state, payload) {
      state.nothing = payload
    },
    setPage(state, payload) {
      state.listQuery.offset = payload
    },
    setShare: (state, payload) => {
      state.share.share_number = payload.share_number
      state.share.share_creater_name = payload.share_creater_name
    },
    setLink(state, payload) {
      state.share.link_number = payload.link_number
      state.share.link_creater_name = payload.link_creater_name
    },
    selectedFolder: (state, payload) => {
      state.selectedFolder = payload
    },
    handleRename: (state, payload) => {
      payload.isEdit = true
      payload.isCreate = false
    },
    setTranscode: (state, payload) => {
      let index = state.datas.indexOf(payload.data)
      if (state.datas[index]) {
        state.datas[index].transcode_title = payload.transcode_title
        state.datas[index].transcode_status = payload.transcode_status
      }
    },
    handleSelectedRename: (state) => {
      state.selectedDatas[0].isEdit = true
      state.selectedDatas[0].isCreate = false
    },
    SWITCH_DRIVE: (state, payload) => {
      state.datas = [];
      // state.loading = false
      // state.listQuery.offset = 0
      if (state.setting.from) {
        state.drive = state.setting.drive
        state.tab = state.setting.tab
        if (state.drive === 'group') {
          state.listQuery.is_star = false
        } else if (state.drive === 'groupdisk') {
          state.listQuery.is_star = false
        }
        state.group = state.setting.group
        state.groupNumber = state.setting.group.group_number
        state.listQuery.group_number = state.setting.group.group_number
        state.listQuery.category = 'all'
        state.listQuery.number = 0
        state.listQuery.disk_type = 'cloud'
      } else {
        state.drive = payload.drive
        state.tab = payload.tab
        if (state.drive === 'group') {
          state.listQuery.is_star = false
        } else if (state.drive === 'persona') {
          state.listQuery.is_star = false
        } else if (state.drive === 'groupdisk') {
          state.listQuery.is_star = false
        }
        // state.group = payload.group
        if (payload.group_number) {
          state.groupNumber = payload.group_number
          state.listQuery.group_number = payload.group_number
        } else {
          state.groupNumber = null;
        }
        state.listQuery.category = 'all'
        state.listQuery.number = 0
        state.listQuery.disk_type = 'cloud'
      }

    },
    SWITCH_TAB: (state, payload) => {
      state.datas = [];
      // state.loading = false
      switch (payload) {
        case 'file':
          state.listQuery = {
            group_number: state.groupNumber,
            number: 0,
            is_rec: false,
            category: 'all',
            disk_type: 'cloud',
            // offset: 0,
            // limit: state.perPage
          }
          break;
        case 'persona-file':
          state.listQuery = {
            group_number: state.groupNumber,
            is_rec: true,
            category: 'file',
            disk_type: 'cloud',
            offset: 0,
            limit: 5
          }
          break;
        case 'star':
          state.listQuery = {
            group_number: state.groupNumber,
            number: 0,
            is_rec: false,
            is_star: true,
            category: 'all',
            disk_type: 'cloud',
            offset: 0,
            limit: state.perPage
          }
          break;
        case 'trash':
          // 回收站中不支持网格模式
          state.isList = true;
          state.listQuery = {
            group_number: state.groupNumber,
            number: 0,
            is_rec: false,
            category: 'all',
            disk_type: 'recycle',
            // offset: 0,
            // limit: state.perPage
          }
          break;
        case 'sharefile':
          state.listQuery = {
            group_number: state.groupNumber,
            share_type: 'user|group|link',
            tags: null,
            search_name: null,
            offset: 0,
            limit: state.perPage
          }
          break;
        case 'persona-sharefile':
          state.listQuery = {
            group_number: state.groupNumber,
            share_type: 'user|group|link',
            tags: null,
            search_name: null,
            offset: 0,
            limit: 5
          }
          break;
        case 'shareme':
          state.listQuery = {
            group_number: state.groupNumber,
            tags: null,
            search_name: null,
            offset: 0,
            limit: state.perPage
          }
          break;
        case 'groupdisk-file':
          state.listQuery = {
            group_number: state.groupNumber,
            number: 0,
            searchName: null,
            is_rec: false,
            is_star: false,
            category: 'all',
            disk_type: 'cloud',
            // offset: 0,
            // limit: state.perPage
          }
          break;
        case 'groupdisk-share':
          state.listQuery = {
            group_number: state.groupNumber,
            tags: null,
            search_name: null,
            offset: 0,
            limit: state.perPage
          }
          break;
        case 'groupdisk-send':
          state.listQuery = {
            group_number: state.groupNumber,
            search_name: null,
            offset: 0,
            limit: state.perPage
          }
          break;
        case 'group-file':
          state.listQuery = {
            group_number: state.groupNumber,
            number: 0,
            is_rec: false,
            category: 'all',
            disk_type: 'cloud',
            // offset: 0,
            // limit: state.perPage
          }
          break;
        case 'group-share':
          state.listQuery = {
            group_number: state.groupNumber,
            share_type: 'group',
            tags: null,
            search_name: null,
            offset: 0,
            limit: state.perPage
          }
          break;
        case 'group-send':
          state.listQuery = {
            group_number: state.groupNumber,
            search_name: null,
            offset: 0,
            limit: state.perPage
          }
          break;
        default:
          state.listQuery = {
            group_number: state.groupNumber,
            number: 0,
            is_rec: false,
            category: 'all',
            disk_type: 'cloud',
            // offset: 0,
            // limit: state.perPage
          }
          break;
      }
      state.tab = payload
      // state.listQuery.category = 'all'
      // state.listQuery.number = 0
    },
    selectOneRow(state, payload) {
      state.selectedDatas = [];
      state.datas.map(function (data) {
        if (data === payload) {
          payload.isSelected = true
          state.selectedDatas.push(payload);
        } else {
          data.isSelected = false;
        }
        return data;
      });
    },
    selectRow: (state, payload) => {
      if (payload.isSelected) {
        let index = state.selectedDatas.indexOf(payload)
        payload.isSelected = false
        state.selectedDatas.splice(index, 1)
      } else {
        payload.isSelected = true
        state.selectedDatas.push(payload);
      }
    },
    toggleSelectAll: (state) => {
      let status = state.selectedDatas.length === 0;
      if (status) {
        state.selectedDatas = state.datas.map((data) => {
          return data;
        })
      } else {
        state.selectedDatas = [];
      }
      state.datas.map(function (data) {
        return (data.isSelected = status ? true : false);
      });
    },
    setSortBy: (state, payload) => {
      state.sort = payload
    },
    sortByDefault(state, payload) {
      state.headers.map(function (item) {
        if (item.id === payload) {
          item.showSort = true;
          item.sort = "des";
          state.sort = item
          return item;
        }
        item.showSort = false;
        item.sort = "des";
        return item;
      });
    },
    sortById(state, payload) {
      state.headers.map(function (item) {
        if (item.id === payload) {
          item.showSort = true;
          item.sort = item.sort === "des" ? "asc" : "des";
          state.sort = item
          return item;
        }
        item.showSort = false;
        item.sort = "des";
        return item;
      });
    },
    sortByHeader(state) {
      if (state.sort.id === 1) {
        state.datas.sort(function (x, y) {
          let ind = x[state.sort.field[state.tab]].localeCompare(y[state.sort.field[state.tab]]);
          return state.sort.sort === "asc" ? ind : -ind;
        })
      } else if (state.sort.id === 5) {
        state.datas.sort(function (x, y) {
          let ind = x[state.sort.field].length - y[state.sort.field].length;
          return state.sort.sort === "asc" ? ind : -ind;
        })
      } else if ([4, 6, 61, 9].indexOf(state.sort.id) > -1) {
        state.datas.sort(function (x, y) {
          let ind = x[state.sort.field].localeCompare(y[state.sort.field]);
          return state.sort.sort === "asc" ? ind : -ind;
        })
      } else if ([3, 7, 71].indexOf(state.sort.id) > -1) {
        state.datas.sort(function (x, y) {
          let ind = new Date(x[state.sort.field]).getTime() - new Date(y[state.sort.field]).getTime();
          return state.sort.sort === "asc" ? ind : -ind;
        })
      } else if (state.sort.id === 8) {
        state.datas.sort(function (x, y) {
          let ind = x[state.sort.field[state.tab]] - y[state.sort.field[state.tab]];
          return state.sort.sort === "asc" ? ind : -ind;
        })
      } else {
        state.datas.sort(function (x, y) {
          let ind = x[state.sort.field] - y[state.sort.field];
          return state.sort.sort === "asc" ? ind : -ind;
        })
      }
      // 仅仅在显示文件的时候需要将文件夹和文件先后排序
      if ([1, 2, 3, 4].indexOf(state.sort.id) > -1) {
        const files = state.datas.filter(item => {
          return item.type === 'file';
        })

        const folders = state.datas.filter(item => {
          return item.type === 'folder';
        })

        state.datas = folders.concat(files);
      }
    },
    GET_INFO: (state, payload) => {
      state.selectedDatas = []
      let datas = payload.map(function (item) {
        item.isSelected = false;
        item.isEdit = false;
        if (item.file_type === 'image') {
          item.imgPath = null
        }
        return item;
      })
      // if(state.listQuery.offset === 0){
      state.datas = datas
      // }else{
      //   state.datas = state.datas.concat(datas)
      // }

      state.share.share_number = null
      state.share.share_creater_name = null
      if (state.setting.from === true) {
        state.setting.from = false
      }
    },
    GET_SHARE_INFO: (state, payload) => {
      state.selectedDatas = []
      let datas = payload.map(function (item) {
        item.isSelected = false;
        item.isEdit = false;
        if (item.file_type === 'image') {
          item.imgPath = null
        }
        return item;
      })
      if (state.listQuery.offset === 0) {
        state.datas = datas
      } else {
        state.datas = state.datas.concat(datas)
      }

      state.share.share_number = null
      state.share.share_creater_name = null
      if (state.setting.from === true) {
        state.setting.from = false
      }
    },
    GET_RESOURCE_INFO: (state, payload) => {
      state.selectedDatas = []
      let datas = payload.map(function (item) {
        item.isSelected = false
        // item.isEdit = false
        if (item.file_type === 'image') {
          item.imgPath = null
        }
        return item
      })
      state.datas = datas
    },
    MODIFY_LIST_QUERY: (state, payload) => {
      state.listQuery.group_number = payload.hasOwnProperty('group_number') ? payload.group_number : state.listQuery.group_number
      state.listQuery.number = payload.hasOwnProperty('number') ? payload.number : state.listQuery.number
      state.listQuery.searchName = payload.hasOwnProperty('searchName') ? payload.searchName : state.listQuery.searchName
      state.listQuery.is_rec = payload.hasOwnProperty('is_rec') ? payload.is_rec : state.listQuery.is_rec
      state.listQuery.is_star = payload.hasOwnProperty('is_star') ? payload.is_star : state.listQuery.is_star
      state.listQuery.category = payload.hasOwnProperty('category') ? payload.category : state.listQuery.category
      state.listQuery.disk_type = payload.hasOwnProperty('disk_type') ? payload.disk_type : state.listQuery.disk_type

      // state.listQuery.type = payload.hasOwnProperty('type') ? payload.type : state.listQuery.type
      // state.listQuery.fatherId = payload.hasOwnProperty('fatherId') ? payload.fatherId : state.listQuery.fatherId
      state.listQuery.tag = payload.hasOwnProperty('tag') ? payload.tag : state.listQuery.tag
      state.listQuery.offset = payload.hasOwnProperty('offset') ? payload.offset : state.listQuery.offset
      state.listQuery.limit = payload.hasOwnProperty('limit') ? payload.limit : state.listQuery.limit
    },
    operationFileOrFolderData: (state, payload) => {
      state.operationFileOrFolderData.action = payload.action
      state.operationFileOrFolderData.number = payload.number
      state.operationFileOrFolderData.group_number = payload.group_number
      state.operationFileOrFolderData.disk_type = payload.disk_type
      state.operationFileOrFolderData.files_list = payload.files_list
    },
    toggleStar: (state, payload) => {
      payload.is_star = !payload.is_star
    },
    // 删除数据(①传入data删除单条数据②传入null删除所有已选择的数据)
    deleteFileOrFolder: (state, data = null) => {
      if (data) {
        let index = state.datas.indexOf(data)
        state.datas.splice(index, 1)
        let index2 = state.selectedDatas.indexOf(data)
        state.selectedDatas.splice(index2, 1)
      } else {
        state.datas = state.datas.filter(item => {
          return !state.selectedDatas.includes(item)
        })
        state.selectedDatas = []
      }
      // 不能在加载的时候设置state.nothing为false，因为此时state.datas为空，将意外的设置state.nothing为true
      if (!state.datas.length && !state.loading) {
        state.nothing = true
      }
    },
    // 重命名文件夹
    RENAME: (state, payload) => {
      payload.data.name = payload.newValue;
      payload.data.last_update_date = payload.last_update_date;
    },
    // 新增文件夹（头部）
    insertNewFolder: (state, payload) => {
      state.nothing = false
      state.datas.unshift(payload)
    },
    // 新增文件夹（第二位）
    createNewFolder: (state, payload) => {
      state.nothing = false
      let index = state.datas.length && state.datas[0].disk_type === 'backup' && state.datas[0].number == 0 ? 1 : 0;
      state.datas.splice(index, 0, payload)
    },
    /**
     * 新建文件夹后获取最新的文件信息并修改到datas中（无刷新新建文件夹） 
     * */
    changeDataOfDatas(state, payload) {
      let data = state.datas.find(item => item.isCreate)
      data.number = payload.number
      data.name = payload.name
      data.creater_user_real_name = payload.creater_user_real_name
      data.isCreate = false
      data.isEdit = false
      data.last_update_date = payload.last_update_date
      data.parent_number = payload.parent_number
      data.parent_path_number = payload.parent_path_number
    },
    // 修改文件版本号(可使用下方changeFileData方法，删除本方法，记得全局搜索修改)
    changeVersion(state, payload) {
      payload.data.version = payload.version;
    },
    // 修改文件
    changeFileData(state, payload) {
      payload.data = Object.assign(payload.data, payload.newData);
    },
    /**
     * 设置图片缩略图地址
     */
    setImgPath(state, payload) {
      if (state.datas[payload.index]) {
        state.datas[payload.index]['imgPath'] = payload.imgPath;
      }
    },
    SET_GROUP_NUMBER: (state, payload) => {
      state.groupNumber = payload;
    },
  },
  actions: {
    /**
     * 获取缩略图地址
     */
    getImgPath({ state, commit }) {
      state.datas.map((item, index) => {
        if (item.file_type === 'image' && !item.imgPath && isThumb(item.file_ext)) {
          download({
            files_list: [item.number],
            group_number: state.groupNumber
          }).then(res => {
            if (res.status_code === 200) {
              let path = res.entity[item.number];
              commit('setImgPath', {
                index: index,
                imgPath: replaceThumbDomain(path)
              })
            }
          })
        }
      })
    },
    /**
    * 获取分享的缩略图地址
    */
    getShareImgPath({ state, commit }) {
      state.datas.map((item, index) => {
        if (item.file_type === 'image' && !item.imgPath && isThumb(item.file_ext)) {
          shareDownload({
            share_number: state.share.share_number,
            share_resources_list: [item.number]
          }).then(res => {
            if (res.status_code === 200) {
              let path = res.entity[item.number];
              commit('setImgPath', {
                index: index,
                imgPath: replaceThumbDomain(path)
              })
            }
          })
        }
      })
    },
    /**
     * 新建文件夹后获取最新的文件信息并修改到datas中（无刷新新建文件夹）（弃用，新建文件夹后返回需要的显示参数） 
     * */
    // getFolderToDatas({commit}, payload){
    //   return new Promise((resolve, reject)=> {
    //     fileOrFolderInfo(payload).then(res => {
    //       commit('changeDataOfDatas', res.entity)
    //       resolve(res)
    //     }).catch(err => {
    //       reject(err)
    //     })
    //   })
    // },
    downloadSelecteds({ state }) {
      let files_list = state.selectedDatas.map(data => {
        return data.number;
      });
      let params = {
        files_list: files_list,
        group_number: state.groupNumber,
      }
      return new Promise((resolve, reject) => {
        download(params).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    downloadShareSelecteds({ state }) {
      let share_resources_list = state.selectedDatas.map(data => {
        return data.number;
      });
      let params = {
        share_number: state.share.share_number,
        share_resources_list: share_resources_list
      }
      return new Promise((resolve, reject) => {
        shareDownload(params).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    searchByTags({ commit }, payload) {
      commit('setDatas', [])
      commit('setLoading', true)
      commit('setNothing', false)
      return new Promise((resolve, reject) => {
        resourceSearch(payload).then(res => {
          commit("setLoading", false);
          commit('GET_INFO', res.entity.datas)
          if (res.entity.total > 0) {
            commit('sortByDefault', 3)
            commit('sortByHeader')
          } else {
            commit('setNothing', true)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 群盘中筛选文件
    searchGroupFileByFilter({ commit }, payload) {
      commit('setDatas', [])
      commit('setLoading', true)
      commit('setNothing', false)
      return new Promise((resolve, reject) => {
        resourceSearch(payload).then(res => {
          commit("setLoading", false);
          if (res.status_code === 200) {
            commit('GET_INFO', res.entity.datas)
            if (res.entity.total > 0) {
              commit('sortByDefault', 3)
              commit('sortByHeader')
            } else {
              commit('setNothing', true)
            }
          } else if (res.status_code === 5021) {
            commit('setNothing', true)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getInfo({ dispatch, commit, state }) {
      if (['star', 'sharefile', 'shareme', 'groupdisk-share', 'groupdisk-send'].indexOf(state.tab) < 0) {
        // if(['sharefile', 'shareme', 'groupdisk-share', 'groupdisk-send'].indexOf(state.tab) < 0 && 'star' != state.tab){
        commit('setDatas', [])
      }
      commit('setLoading', true)
      commit('setNothing', false)
      let res;
      switch (state.tab) {
        case 'star':
          res = dispatch('getStarFileInfo')
          break;
        case 'persona-file':
          res = dispatch('getPersonFileInfo')
          break;
        case 'persona-sharefile':
          res = dispatch('getShareFileInfo')
          break;
        case 'sharefile':
          res = dispatch('getShareFileInfo')
          break;
        case 'shareme':
          res = dispatch('getShareMeInfo')
          break;
        case 'groupdisk-file':
          res = dispatch('getGroupFileInfo')
          break;
        case 'groupdisk-share':
          res = dispatch('getGroupShareInfo')
          break;
        case 'groupdisk-send':
          res = dispatch('getGroupSendInfo')
          break;
        case 'group-file':
          res = dispatch('getGroupFileInfo')
          break;
        case 'group-share':
          res = dispatch('getGroupShareInfo')
          break;
        case 'group-send':
          res = dispatch('getGroupSendInfo')
          break;
        default:
          // 当tab为file,trash,persona-file(其实group-file也可以用，但其有了getGroupFileInfo)
          res = dispatch('getFileInfo')
          break;
      }
      return res;
    },
    // 获取发布资源列表
    getLinkResourceList({ commit, state }, payload) {
      commit('setDatas', [])
      commit('setLoading', true)
      commit('setNothing', false)
      commit('setShareExpired', false)
      return new Promise((resolve, reject) => {
        if (payload.link_creater_name) {
          commit('setLink', payload)
          delete (payload.link_creater_name)
        }
        linkResourceList(payload).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 获取分享资源列表
    getShareResourceList({ commit, state }, payload) {
      commit('setDatas', [])
      commit('setLoading', true)
      commit('setNothing', false)
      commit('setShareExpired', false)
      return new Promise((resolve, reject) => {
        if (payload.share_creater_name) {
          commit('setShare', payload)
          delete (payload.share_creater_name)
        }
        if (['sharefile', 'persona-sharefile'].indexOf(state.tab) > -1) {
          shareResourceList(payload).then(res => {
            resolve(res)
          }).catch(err => {
            reject(err)
          })
        } else if (['shareme', 'groupdisk-share'].indexOf(state.tab) > -1) {
          shareTargetResourceList(payload).then(res => {
            resolve(res)
          }).catch(err => {
            reject(err)
          })
        }
      })
    },
    getFileInfo({ commit, state, rootState }) {
      return new Promise((resolve, reject) => {
        getFileInfo(state.listQuery).then(res => {
          commit("setLoading", false);
          if (res.status_code == 200) {
            commit('GET_INFO', res.entity.datas)
            if (rootState.user.userInfo.is_backup_file
              && state.tab === 'file'
              && state.listQuery.number == '0'
              && state.listQuery.disk_type === 'cloud') {
              commit('insertNewFolder', {
                number: 0,
                group_number: null,
                name: "备份文件夹",
                type: "folder",
                bytes: "",
                last_update_date: "-",
                creater_user_real_name: "-",
                isStar: false,
                disk_type: "backup",
                isEdit: false,
                isCreate: false,
                isSelected: false
              })
            }
            if (res.entity.total > 0) {
              commit('sortByDefault', 3)
              commit('sortByHeader')
            } else {
              commit('setNothing', true)
            }
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getPersonFileInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        resourceSearch(state.listQuery).then(res => {
          commit("setLoading", false);
          commit('GET_INFO', res.entity.datas)
          if (res.entity.total > 0) {
            commit('sortByDefault', 3)
            commit('sortByHeader')
          } else {
            commit('setNothing', true)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getStarFileInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.listQuery.number != 0) {
          commit('setDatas', [])
          commit('MODIFY_LIST_QUERY', { is_star: false })
          getFileInfo(state.listQuery).then(res => {
            commit("setLoading", false);
            commit('GET_INFO', res.entity.datas)
            commit('setTotal', res.entity.total)
            if (res.entity.total > 0) {
              commit('sortByDefault', 3)
              commit('sortByHeader')
            } else {
              commit('setNothing', true)
            }
            resolve(res)
          }).catch(err => {
            reject(err)
          })
        } else if (state.listQuery.number == 0) {
          commit('MODIFY_LIST_QUERY', { is_star: true })
          resourceSearch(state.listQuery).then(res => {
            commit("setLoading", false);
            commit('GET_SHARE_INFO', res.entity.datas)
            commit('setTotal', res.entity.total)
            if (res.entity.total > 0) {
              commit('sortByDefault', 3)
              commit('sortByHeader')
            } else {
              commit('setNothing', true)
            }
            resolve(res)
          }).catch(err => {
            reject(err)
          })
        }
      })
    },
    getShareFileInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        shareList(state.listQuery).then(res => {
          commit("setLoading", false);
          commit('GET_SHARE_INFO', res.entity.datas)
          commit('setTotal', res.entity.total)
          if (res.entity.total > 0) {
            commit('sortByDefault', 7)
            commit('sortByHeader')
          } else {
            commit('setNothing', true)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getShareMeInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        shareUserList(state.listQuery).then(res => {
          commit("setLoading", false);
          commit('GET_SHARE_INFO', res.entity.datas)
          commit('setTotal', res.entity.total)
          if (res.entity.total > 0) {
            commit('sortByDefault', 7)
            commit('sortByHeader')
          } else {
            commit('setNothing', true)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getGroupFileInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getFileInfo(state.listQuery).then(res => {
          commit("setLoading", false);
          if (res.status_code === 200) {
            commit('GET_INFO', res.entity.datas)
            if (res.entity.total > 0) {
              commit('sortByDefault', 3)
              commit('sortByHeader')
            } else {
              commit('setNothing', true)
            }
          } else {
            commit('GET_INFO', [])
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getGroupShareInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        shareUserList(state.listQuery).then(res => {
          commit("setLoading", false);
          commit('GET_SHARE_INFO', res.entity.datas)
          commit('setTotal', res.entity.total)
          if (res.entity.total > 0) {
            commit('sortByDefault', 7)
            commit('sortByHeader')
          } else {
            commit('setNothing', true)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getGroupSendInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getLinkList(state.listQuery).then(res => {
          commit("setLoading", false);
          commit('GET_SHARE_INFO', res.entity.datas)
          commit('setTotal', res.entity.total)
          if (res.entity.total > 0) {
            commit('sortByDefault', 71)
            commit('sortByHeader')
          } else {
            commit('setNothing', true)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    newFolders({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        newFolders(payload).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    toggleStar({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          is_star: !payload.is_star,
          paramslist: [
            {
              number: payload.number,
              type: payload.type,
              group_number: state.groupNumber
            }
          ]
        };
        toggleStar(data).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 移动
    moveToFolder({ state }) {
      return new Promise((resolve, reject) => {
        operationFileOrFolder(state.operationFileOrFolderData).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 复制
    copyToFolder({ state }) {
      return new Promise((resolve, reject) => {
        operationFileOrFolder(state.operationFileOrFolderData).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存
    saveToFolder({ state }) {
      return new Promise((resolve, reject) => {
        operationFileOrFolder(state.operationFileOrFolderData).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 还原
    restoreToFolder({ state }) {
      return new Promise((resolve, reject) => {
        operationFileOrFolder(state.operationFileOrFolderData).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 涉及将当前条目去除的
    handleFileOrFolder({ state }) {
      return new Promise((resolve, reject) => {
        operationFileOrFolder(state.operationFileOrFolderData).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    //批量删除
    deleteFileOrFolders({ state }) {
      let files_list = state.selectedDatas.map(data => {
        return { number: data.number, type: data.type };
      });
      let params = {
        group_number: state.groupNumber,
        action: "recycle",
        disk_type: state.selectedDatas[0].disk_type,
        files_list: files_list
      }
      return new Promise((resolve, reject) => {
        operationFileOrFolder(params).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    rename({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rename(payload).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 批量删除分享(创建人)
    deleteShares({ state }, payload) {
      return new Promise((resolve, reject) => {
        deleteShare(payload).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 批量删除分享(接收人)
    removeShares({ state }, payload) {
      return new Promise((resolve, reject) => {
        removeShare(payload).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 批量删除发布(创建人)
    deleteLinks({ state }, payload) {
      return new Promise((resolve, reject) => {
        deleteLinks(payload).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default drive